import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const MovingCompany = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my moving company business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps moving company businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for moving company businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most moving company businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my moving company business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like moving company. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Moving Company - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Moving Company CRM", url: "/industries/moving-company" }
  ];

  const industryData = {
    name: 'Moving Company',
    title: 'Capture Last-Minute Moving Requests & Fill Your Schedule Faster',
    subtitle: 'Never miss an urgent move request, automate estimates, and manage bookings without endless phone calls',
    icon: '🚚',
    challenges: [
      'Missing calls during moves = lost business',
      'Too much time spent on phone estimates',
      'Last-minute cancellations leave trucks idle',
      'Hard to manage crew scheduling',
      'Difficult to get final payment'
    ],
    solutions: [
      'Instant move request capture 24/7',
      'Online inventory-based estimates',
      'Automated scheduling and crew assignment',
      'Cancellation waitlist automation',
      'Payment tracking and automation'
    ],
    features: [
      'Lead CRM with move details',
      'Online estimate calculator',
      'Crew scheduling automation',
      'Truck and equipment tracking',
      'Move day reminders',
      'Payment processing',
      'Review automation',
      'Storage client management'
    ],
    results: [
      'Capture 100% of move requests',
      '60% faster estimate turnaround',
      'Fill 90% of cancellation slots',
      '£6.8K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Moving Company UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for moving company businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for moving company UK, moving company business software, moving company customer management, moving company lead generation UK"
        url="/industries/moving-company"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default MovingCompany;